import { render, staticRenderFns } from "./stars_info_card.vue?vue&type=template&id=ee694c44&scoped=true&"
import script from "./stars_info_card.vue?vue&type=script&lang=js&"
export * from "./stars_info_card.vue?vue&type=script&lang=js&"
import style0 from "./stars_info_card.vue?vue&type=style&index=0&id=ee694c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee694c44",
  null
  
)

export default component.exports